module.exports = __webpack_public_path__ + "static/media/Machine_Tests_m_mr.b199d1aa.jpg";